/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const isExistingCustomer = /* GraphQL */ `
  query IsExistingCustomer($email: String) {
    isExistingCustomer(email: $email) {
      exists
      customer {
        id
        firstName
        lastName
        email
        status
      }
    }
  }
`;
export const getAvailableStockQty = /* GraphQL */ `
  query GetAvailableStockQty($input: GetAvailableStockQtyInput!) {
    getAvailableStockQty(input: $input) {
      productId
      locationQty {
        location
        qty
      }
    }
  }
`;
export const validateCoupon = /* GraphQL */ `
  query ValidateCoupon($input: ValidateCouponInput!) {
    validateCoupon(input: $input) {
      company
      id
      description
      type
      status
      expireAt
      startTime
      value
      settings {
        company
        parentId
        settingId
        value
        createdAt
        updatedAt
      }
      qtyAvailable
      qtyReserved
      qtyUsed
      minSpend
      maxSpend
      createdAt
      updatedAt
      version
      products {
        items {
          company
          id
          couponId
          productId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      status
      plan
      email
      timeZone
      locale
      country
      currency
      billingDetails {
        processor
        currency
        nextPaymentDate
        nextPaymentAmount
      }
      cards
      settings {
        company
        parentId
        settingId
        value
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
      accountPayments {
        items {
          company
          id
          plan
          status
          currency
          totalGross
          totalFee
          totalNet
          processor
          processorData
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $id: ID
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCompanys(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        status
        plan
        email
        timeZone
        locale
        country
        currency
        billingDetails {
          processor
          currency
          nextPaymentDate
          nextPaymentAmount
        }
        cards
        settings {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        accountPayments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCompaniesByStatus = /* GraphQL */ `
  query ListCompaniesByStatus(
    $status: CompanyStatusEnum
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesByStatus(
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        plan
        email
        timeZone
        locale
        country
        currency
        billingDetails {
          processor
          currency
          nextPaymentDate
          nextPaymentAmount
        }
        cards
        settings {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
        accountPayments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($company: ID!, $id: ID!) {
    getLocation(company: $company, id: $id) {
      company
      id
      createdAt
      name
      description
      type
      email
      phoneNumber
      physicalAddress {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      updatedAt
      settings {
        items {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelLocationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLocations(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        createdAt
        name
        description
        type
        email
        phoneNumber
        physicalAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        updatedAt
        settings {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getSetting = /* GraphQL */ `
  query GetSetting($company: ID!, $parentId: ID!, $settingId: String!) {
    getSetting(company: $company, parentId: $parentId, settingId: $settingId) {
      company
      parentId
      settingId
      value
      createdAt
      updatedAt
    }
  }
`;
export const listSettings = /* GraphQL */ `
  query ListSettings(
    $company: ID
    $parentIdSettingId: ModelSettingPrimaryCompositeKeyConditionInput
    $filter: ModelSettingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSettings(
      company: $company
      parentIdSettingId: $parentIdSettingId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        parentId
        settingId
        value
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAccountPayment = /* GraphQL */ `
  query GetAccountPayment($company: ID!, $id: ID!) {
    getAccountPayment(company: $company, id: $id) {
      company
      id
      plan
      status
      currency
      totalGross
      totalFee
      totalNet
      processor
      processorData
      createdAt
      updatedAt
    }
  }
`;
export const listAccountPayments = /* GraphQL */ `
  query ListAccountPayments(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelAccountPaymentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccountPayments(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        plan
        status
        currency
        totalGross
        totalFee
        totalNet
        processor
        processorData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listAccountPaymentsByCreateTime = /* GraphQL */ `
  query ListAccountPaymentsByCreateTime(
    $company: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccountPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccountPaymentsByCreateTime(
      company: $company
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        plan
        status
        currency
        totalGross
        totalFee
        totalNet
        processor
        processorData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($company: ID!, $id: ID!) {
    getCustomer(company: $company, id: $id) {
      company
      id
      email
      firstName
      lastName
      physicalAddress {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      billingAddress {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCustomers(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        email
        firstName
        lastName
        physicalAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchCustomers = /* GraphQL */ `
  query SearchCustomers(
    $filter: SearchableCustomerFilterInput
    $sort: SearchableCustomerSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCustomers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        company
        id
        email
        firstName
        lastName
        physicalAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
      nextToken
      total
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($company: ID!, $id: ID!) {
    getPayment(company: $company, id: $id) {
      company
      id
      customerId
      orderId
      status
      currency
      originalCurrency
      conversionRate
      totalGross
      totalFee
      totalNet
      processorId
      extPaymentId
      processorData
      createdAt
      reason
      updatedAt
      customer {
        company
        id
        email
        firstName
        lastName
        physicalAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
      processor {
        company
        id
        name
        description
        active
        formValues {
          name
          type
          value
        }
        createdAt
        updatedAt
        processor {
          id
          name
          description
          active
          logo
          countries
          website
          createdAt
          updatedAt
        }
      }
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPayments(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        customerId
        orderId
        status
        currency
        originalCurrency
        conversionRate
        totalGross
        totalFee
        totalNet
        processorId
        extPaymentId
        processorData
        createdAt
        reason
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        processor {
          company
          id
          name
          description
          active
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listPaymentsByOrderId = /* GraphQL */ `
  query ListPaymentsByOrderId(
    $company: ID
    $orderId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByOrderId(
      company: $company
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        customerId
        orderId
        status
        currency
        originalCurrency
        conversionRate
        totalGross
        totalFee
        totalNet
        processorId
        extPaymentId
        processorData
        createdAt
        reason
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        processor {
          company
          id
          name
          description
          active
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listPaymentsByExtPaymentId = /* GraphQL */ `
  query ListPaymentsByExtPaymentId(
    $extPaymentId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByExtPaymentId(
      extPaymentId: $extPaymentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        customerId
        orderId
        status
        currency
        originalCurrency
        conversionRate
        totalGross
        totalFee
        totalNet
        processorId
        extPaymentId
        processorData
        createdAt
        reason
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        processor {
          company
          id
          name
          description
          active
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listPaymentsByOrderIdCreateTime = /* GraphQL */ `
  query ListPaymentsByOrderIdCreateTime(
    $company: ID
    $orderIdCreatedAt: ModelPaymentByOrderIdCreatedTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPaymentsByOrderIdCreateTime(
      company: $company
      orderIdCreatedAt: $orderIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        customerId
        orderId
        status
        currency
        originalCurrency
        conversionRate
        totalGross
        totalFee
        totalNet
        processorId
        extPaymentId
        processorData
        createdAt
        reason
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        processor {
          company
          id
          name
          description
          active
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchPayments = /* GraphQL */ `
  query SearchPayments(
    $filter: SearchablePaymentFilterInput
    $sort: SearchablePaymentSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPayments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        company
        id
        customerId
        orderId
        status
        currency
        originalCurrency
        conversionRate
        totalGross
        totalFee
        totalNet
        processorId
        extPaymentId
        processorData
        createdAt
        reason
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        processor {
          company
          id
          name
          description
          active
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const getPaymentProcessor = /* GraphQL */ `
  query GetPaymentProcessor($id: ID!) {
    getPaymentProcessor(id: $id) {
      id
      name
      description
      active
      logo
      formFields {
        name
        type
        required
        tooltip
      }
      countries
      website
      createdAt
      updatedAt
    }
  }
`;
export const listPaymentProcessors = /* GraphQL */ `
  query ListPaymentProcessors(
    $id: ID
    $filter: ModelPaymentProcessorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPaymentProcessors(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        active
        logo
        formFields {
          name
          type
          required
          tooltip
        }
        countries
        website
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyPaymentProcessor = /* GraphQL */ `
  query GetCompanyPaymentProcessor($company: ID!, $id: ID!) {
    getCompanyPaymentProcessor(company: $company, id: $id) {
      company
      id
      name
      description
      active
      formValues {
        name
        type
        value
      }
      createdAt
      updatedAt
      processor {
        id
        name
        description
        active
        logo
        formFields {
          name
          type
          required
          tooltip
        }
        countries
        website
        createdAt
        updatedAt
      }
    }
  }
`;
export const listCompanyPaymentProcessors = /* GraphQL */ `
  query ListCompanyPaymentProcessors(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCompanyPaymentProcessorFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCompanyPaymentProcessors(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        name
        description
        active
        formValues {
          name
          type
          value
        }
        createdAt
        updatedAt
        processor {
          id
          name
          description
          active
          logo
          countries
          website
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getSequence = /* GraphQL */ `
  query GetSequence($company: ID!, $id: ID!) {
    getSequence(company: $company, id: $id) {
      company
      id
      version
      createdAt
      updatedAt
    }
  }
`;
export const listSequences = /* GraphQL */ `
  query ListSequences(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelSequenceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSequences(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        version
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($company: ID!, $id: ID!) {
    getOrder(company: $company, id: $id) {
      company
      id
      type
      status
      ref
      locationId
      customerId
      customerEmail
      customerFirstName
      customerLastName
      owner
      categoryId
      startTime
      endTime
      contactNumber
      deliveryType
      billingAddress {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      deliveryAddress {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      deliveryTime
      returnedTime
      confirmedTime
      deliveredTime
      total
      deposit
      subTotal
      discountTotal
      deliveryFee
      reason
      notes
      createdAt
      completedAt
      attributes {
        name
        type
        value
      }
      updatedAt
      customer {
        company
        id
        email
        firstName
        lastName
        physicalAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
      payments {
        items {
          company
          id
          customerId
          orderId
          status
          currency
          originalCurrency
          conversionRate
          totalGross
          totalFee
          totalNet
          processorId
          extPaymentId
          processorData
          createdAt
          reason
          updatedAt
        }
        nextToken
      }
      products {
        items {
          company
          id
          orderId
          productId
          owner
          orderType
          startTime
          endTime
          qty
          total
          subTotal
          discountTotal
          createdAt
          updatedAt
        }
        nextToken
      }
      coupons {
        items {
          company
          id
          orderId
          couponId
          owner
          discountTotal
          createdAt
          updatedAt
        }
        nextToken
      }
      stockItems {
        items {
          company
          id
          orderId
          stockItemId
          orderType
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      logs {
        items {
          company
          id
          parentId
          event
          source
          destination
          description
          data
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrders(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByStartTime = /* GraphQL */ `
  query ListOrdersByStartTime(
    $company: ID
    $startTime: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByStartTime(
      company: $company
      startTime: $startTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByStatusStartTime = /* GraphQL */ `
  query ListOrdersByStatusStartTime(
    $company: ID
    $statusStartTime: ModelOrderByStatusStartTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByStatusStartTime(
      company: $company
      statusStartTime: $statusStartTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByStatusEndTime = /* GraphQL */ `
  query ListOrdersByStatusEndTime(
    $company: ID
    $statusEndTime: ModelOrderByStatusEndTimeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByStatusEndTime(
      company: $company
      statusEndTime: $statusEndTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByCompletedAt = /* GraphQL */ `
  query ListOrdersByCompletedAt(
    $status: OrderStatusEnum
    $companyCompletedAt: ModelOrderByStatusCompletedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByCompletedAt(
      status: $status
      companyCompletedAt: $companyCompletedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByCustomerId = /* GraphQL */ `
  query ListOrdersByCustomerId(
    $company: ID
    $customerIdCreatedAt: ModelOrderByCustomerIdCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByCustomerId(
      company: $company
      customerIdCreatedAt: $customerIdCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listOrdersByRef = /* GraphQL */ `
  query ListOrdersByRef(
    $ref: String
    $company: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByRef(
      ref: $ref
      company: $company
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const searchOrders = /* GraphQL */ `
  query SearchOrders(
    $filter: SearchableOrderFilterInput
    $sort: SearchableOrderSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchOrders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getOrderProduct = /* GraphQL */ `
  query GetOrderProduct($company: ID!, $id: ID!) {
    getOrderProduct(company: $company, id: $id) {
      company
      id
      orderId
      productId
      owner
      productInfo {
        name
        categoryId
        description
        dimensions {
          height
          width
          weight
          length
        }
        imageUrl
        price
      }
      orderType
      startTime
      endTime
      qty
      total
      subTotal
      discountTotal
      createdAt
      updatedAt
      order {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listOrderProducts = /* GraphQL */ `
  query ListOrderProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelOrderProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrderProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        orderId
        productId
        owner
        productInfo {
          name
          categoryId
          description
          imageUrl
          price
        }
        orderType
        startTime
        endTime
        qty
        total
        subTotal
        discountTotal
        createdAt
        updatedAt
        order {
          company
          id
          type
          status
          ref
          locationId
          customerId
          customerEmail
          customerFirstName
          customerLastName
          owner
          categoryId
          startTime
          endTime
          contactNumber
          deliveryType
          deliveryTime
          returnedTime
          confirmedTime
          deliveredTime
          total
          deposit
          subTotal
          discountTotal
          deliveryFee
          reason
          notes
          createdAt
          completedAt
          updatedAt
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listOrderItemsByProduct = /* GraphQL */ `
  query ListOrderItemsByProduct(
    $company: ID
    $productIdStartTime: ModelOrderProductByProductCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemsByProduct(
      company: $company
      productIdStartTime: $productIdStartTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        orderId
        productId
        owner
        productInfo {
          name
          categoryId
          description
          imageUrl
          price
        }
        orderType
        startTime
        endTime
        qty
        total
        subTotal
        discountTotal
        createdAt
        updatedAt
        order {
          company
          id
          type
          status
          ref
          locationId
          customerId
          customerEmail
          customerFirstName
          customerLastName
          owner
          categoryId
          startTime
          endTime
          contactNumber
          deliveryType
          deliveryTime
          returnedTime
          confirmedTime
          deliveredTime
          total
          deposit
          subTotal
          discountTotal
          deliveryFee
          reason
          notes
          createdAt
          completedAt
          updatedAt
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getOrderCoupon = /* GraphQL */ `
  query GetOrderCoupon($company: ID!, $id: ID!) {
    getOrderCoupon(company: $company, id: $id) {
      company
      id
      orderId
      couponId
      owner
      coupon {
        company
        id
        description
        type
        status
        expireAt
        startTime
        value
        settings {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        qtyAvailable
        qtyReserved
        qtyUsed
        minSpend
        maxSpend
        createdAt
        updatedAt
        version
        products {
          nextToken
        }
      }
      discountTotal
      createdAt
      updatedAt
      order {
        company
        id
        type
        status
        ref
        locationId
        customerId
        customerEmail
        customerFirstName
        customerLastName
        owner
        categoryId
        startTime
        endTime
        contactNumber
        deliveryType
        billingAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryAddress {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        deliveryTime
        returnedTime
        confirmedTime
        deliveredTime
        total
        deposit
        subTotal
        discountTotal
        deliveryFee
        reason
        notes
        createdAt
        completedAt
        attributes {
          name
          type
          value
        }
        updatedAt
        customer {
          company
          id
          email
          firstName
          lastName
          createdAt
          updatedAt
        }
        payments {
          nextToken
        }
        products {
          nextToken
        }
        coupons {
          nextToken
        }
        stockItems {
          nextToken
        }
        logs {
          nextToken
        }
      }
    }
  }
`;
export const listOrderCoupons = /* GraphQL */ `
  query ListOrderCoupons(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelOrderCouponFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrderCoupons(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        orderId
        couponId
        owner
        coupon {
          company
          id
          description
          type
          status
          expireAt
          startTime
          value
          qtyAvailable
          qtyReserved
          qtyUsed
          minSpend
          maxSpend
          createdAt
          updatedAt
          version
        }
        discountTotal
        createdAt
        updatedAt
        order {
          company
          id
          type
          status
          ref
          locationId
          customerId
          customerEmail
          customerFirstName
          customerLastName
          owner
          categoryId
          startTime
          endTime
          contactNumber
          deliveryType
          deliveryTime
          returnedTime
          confirmedTime
          deliveredTime
          total
          deposit
          subTotal
          discountTotal
          deliveryFee
          reason
          notes
          createdAt
          completedAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listOrderCouponsByCouponId = /* GraphQL */ `
  query ListOrderCouponsByCouponId(
    $company: ID
    $couponId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderCouponsByCouponId(
      company: $company
      couponId: $couponId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        orderId
        couponId
        owner
        coupon {
          company
          id
          description
          type
          status
          expireAt
          startTime
          value
          qtyAvailable
          qtyReserved
          qtyUsed
          minSpend
          maxSpend
          createdAt
          updatedAt
          version
        }
        discountTotal
        createdAt
        updatedAt
        order {
          company
          id
          type
          status
          ref
          locationId
          customerId
          customerEmail
          customerFirstName
          customerLastName
          owner
          categoryId
          startTime
          endTime
          contactNumber
          deliveryType
          deliveryTime
          returnedTime
          confirmedTime
          deliveredTime
          total
          deposit
          subTotal
          discountTotal
          deliveryFee
          reason
          notes
          createdAt
          completedAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listOrderCouponsByOwner = /* GraphQL */ `
  query ListOrderCouponsByOwner(
    $owner: ID
    $company: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderCouponsByOwner(
      owner: $owner
      company: $company
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        orderId
        couponId
        owner
        coupon {
          company
          id
          description
          type
          status
          expireAt
          startTime
          value
          qtyAvailable
          qtyReserved
          qtyUsed
          minSpend
          maxSpend
          createdAt
          updatedAt
          version
        }
        discountTotal
        createdAt
        updatedAt
        order {
          company
          id
          type
          status
          ref
          locationId
          customerId
          customerEmail
          customerFirstName
          customerLastName
          owner
          categoryId
          startTime
          endTime
          contactNumber
          deliveryType
          deliveryTime
          returnedTime
          confirmedTime
          deliveredTime
          total
          deposit
          subTotal
          discountTotal
          deliveryFee
          reason
          notes
          createdAt
          completedAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getOrderStockItem = /* GraphQL */ `
  query GetOrderStockItem($company: ID!, $id: ID!) {
    getOrderStockItem(company: $company, id: $id) {
      company
      id
      orderId
      stockItemId
      orderType
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listOrderStockItems = /* GraphQL */ `
  query ListOrderStockItems(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelOrderStockItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrderStockItems(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        orderId
        stockItemId
        orderType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const listOrderStockItemByOrder = /* GraphQL */ `
  query ListOrderStockItemByOrder(
    $company: ID
    $orderId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderStockItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderStockItemByOrder(
      company: $company
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        orderId
        stockItemId
        orderType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const listOrderStockItemByProduct = /* GraphQL */ `
  query ListOrderStockItemByProduct(
    $company: ID
    $stockItemId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderStockItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderStockItemByProduct(
      company: $company
      stockItemId: $stockItemId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        orderId
        stockItemId
        orderType
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($company: ID!, $id: ID!) {
    getProduct(company: $company, id: $id) {
      company
      id
      comloc
      sku
      type
      name
      slug
      excerpt
      mediaId
      description
      attributes {
        name
        type
        value
      }
      status
      price
      deposit
      cost
      dimensions {
        height
        width
        weight
        length
      }
      qtyOnHand
      qtyAvailable
      qtyReserved
      createdAt
      updatedAt
      version
      settings {
        items {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        nextToken
      }
      bundleProducts {
        items {
          company
          id
          parentId
          productId
          createdAt
          updatedAt
        }
        nextToken
      }
      features {
        items {
          company
          id
          parentId
          categoryId
          text
          description
          imageUrl
          seq
          createdAt
          updatedAt
        }
        nextToken
      }
      stockItems {
        items {
          company
          id
          location
          serialNumber
          status
          productId
          createdAt
          updatedAt
        }
        nextToken
      }
      categories {
        items {
          company
          id
          categoryId
          productId
          seq
          createdAt
          updatedAt
        }
        nextToken
      }
      upsellProducts {
        items {
          company
          id
          parentId
          productId
          seq
          createdAt
          updatedAt
        }
        nextToken
      }
      crossSellProducts {
        items {
          company
          id
          parentId
          productId
          seq
          createdAt
          updatedAt
        }
        nextToken
      }
      image {
        company
        id
        url
        name
        attributes {
          name
          type
          value
        }
        createdAt
        updatedAt
      }
      media {
        items {
          company
          id
          mediaId
          parentId
          default
          createdAt
          updatedAt
        }
        nextToken
      }
      customPrice {
        items {
          company
          id
          productId
          startTime
          endTime
          price
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listProductsByType = /* GraphQL */ `
  query ListProductsByType(
    $company: ID
    $typeName: ModelProductListProductsByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByType(
      company: $company
      typeName: $typeName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listProductsByStatus = /* GraphQL */ `
  query ListProductsByStatus(
    $company: ID
    $typeStatusName: ModelProductListProductsByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByStatus(
      company: $company
      typeStatusName: $typeStatusName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listLocationProductsByType = /* GraphQL */ `
  query ListLocationProductsByType(
    $comloc: String
    $typeStatusName: ModelProductListLocationProductsByTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationProductsByType(
      comloc: $comloc
      typeStatusName: $typeStatusName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getBundleProduct = /* GraphQL */ `
  query GetBundleProduct($company: ID!, $id: ID!) {
    getBundleProduct(company: $company, id: $id) {
      company
      id
      parentId
      productId
      createdAt
      updatedAt
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listBundleProducts = /* GraphQL */ `
  query ListBundleProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelBundleProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listBundleProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listBundleProductByParentId = /* GraphQL */ `
  query ListBundleProductByParentId(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBundleProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBundleProductByParentId(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listBundleProductByProductId = /* GraphQL */ `
  query ListBundleProductByProductId(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBundleProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBundleProductByProductId(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getFeature = /* GraphQL */ `
  query GetFeature($company: ID!, $id: ID!) {
    getFeature(company: $company, id: $id) {
      company
      id
      parentId
      categoryId
      text
      description
      imageUrl
      seq
      createdAt
      updatedAt
    }
  }
`;
export const listFeatures = /* GraphQL */ `
  query ListFeatures(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelFeatureFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFeatures(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        categoryId
        text
        description
        imageUrl
        seq
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCoupon = /* GraphQL */ `
  query GetCoupon($company: ID!, $id: ID!) {
    getCoupon(company: $company, id: $id) {
      company
      id
      description
      type
      status
      expireAt
      startTime
      value
      settings {
        company
        parentId
        settingId
        value
        createdAt
        updatedAt
      }
      qtyAvailable
      qtyReserved
      qtyUsed
      minSpend
      maxSpend
      createdAt
      updatedAt
      version
      products {
        items {
          company
          id
          couponId
          productId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listCoupons = /* GraphQL */ `
  query ListCoupons(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCoupons(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        description
        type
        status
        expireAt
        startTime
        value
        settings {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        qtyAvailable
        qtyReserved
        qtyUsed
        minSpend
        maxSpend
        createdAt
        updatedAt
        version
        products {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCouponsByStatusExpiry = /* GraphQL */ `
  query ListCouponsByStatusExpiry(
    $company: ID
    $statusExpireAt: ModelCouponByStatusExpireAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponsByStatusExpiry(
      company: $company
      statusExpireAt: $statusExpireAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        description
        type
        status
        expireAt
        startTime
        value
        settings {
          company
          parentId
          settingId
          value
          createdAt
          updatedAt
        }
        qtyAvailable
        qtyReserved
        qtyUsed
        minSpend
        maxSpend
        createdAt
        updatedAt
        version
        products {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCouponProduct = /* GraphQL */ `
  query GetCouponProduct($company: ID!, $id: ID!) {
    getCouponProduct(company: $company, id: $id) {
      company
      id
      couponId
      productId
      createdAt
      updatedAt
    }
  }
`;
export const listCouponProducts = /* GraphQL */ `
  query ListCouponProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCouponProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCouponProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        couponId
        productId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCouponProductByCouponId = /* GraphQL */ `
  query ListCouponProductByCouponId(
    $company: ID
    $couponId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponProductByCouponId(
      company: $company
      couponId: $couponId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        couponId
        productId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listCouponProductByProductId = /* GraphQL */ `
  query ListCouponProductByProductId(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCouponProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCouponProductByProductId(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        couponId
        productId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getStockItem = /* GraphQL */ `
  query GetStockItem($company: ID!, $id: ID!) {
    getStockItem(company: $company, id: $id) {
      company
      id
      location
      serialNumber
      status
      productId
      createdAt
      updatedAt
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listStockItems = /* GraphQL */ `
  query ListStockItems(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelStockItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listStockItems(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        location
        serialNumber
        status
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listStockItemsByProduct = /* GraphQL */ `
  query ListStockItemsByProduct(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStockItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStockItemsByProduct(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        location
        serialNumber
        status
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listLocationStockItems = /* GraphQL */ `
  query ListLocationStockItems(
    $company: ID
    $location: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStockItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLocationStockItems(
      company: $company
      location: $location
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        location
        serialNumber
        status
        productId
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($company: ID!, $id: ID!) {
    getProductCategory(company: $company, id: $id) {
      company
      id
      categoryId
      productId
      seq
      createdAt
      updatedAt
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      category {
        company
        id
        name
        description
        slug
        imageUrl
        parentId
        seq
        hidden
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
      }
    }
  }
`;
export const listProductCategorys = /* GraphQL */ `
  query ListProductCategorys(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProductCategorys(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        categoryId
        productId
        seq
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        category {
          company
          id
          name
          description
          slug
          imageUrl
          parentId
          seq
          hidden
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listCategoriesByProduct = /* GraphQL */ `
  query ListCategoriesByProduct(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByProduct(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        categoryId
        productId
        seq
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        category {
          company
          id
          name
          description
          slug
          imageUrl
          parentId
          seq
          hidden
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listProductsByCategory = /* GraphQL */ `
  query ListProductsByCategory(
    $company: ID
    $categoryIdSeq: ModelProductCategoryByCategorySeqCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductsByCategory(
      company: $company
      categoryIdSeq: $categoryIdSeq
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        categoryId
        productId
        seq
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        category {
          company
          id
          name
          description
          slug
          imageUrl
          parentId
          seq
          hidden
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchProductCategorys = /* GraphQL */ `
  query SearchProductCategorys(
    $filter: SearchableProductCategoryFilterInput
    $sort: SearchableProductCategorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchProductCategorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        company
        id
        categoryId
        productId
        seq
        createdAt
        updatedAt
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        category {
          company
          id
          name
          description
          slug
          imageUrl
          parentId
          seq
          hidden
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const getRelatedProduct = /* GraphQL */ `
  query GetRelatedProduct($company: ID!, $id: ID!) {
    getRelatedProduct(company: $company, id: $id) {
      company
      id
      parentId
      productId
      seq
      createdAt
      updatedAt
      parent {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listRelatedProducts = /* GraphQL */ `
  query ListRelatedProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelRelatedProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRelatedProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listRelatedProductsByProduct = /* GraphQL */ `
  query ListRelatedProductsByProduct(
    $company: ID
    $productId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedProductsByProduct(
      company: $company
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listRelatedProductsByParent = /* GraphQL */ `
  query ListRelatedProductsByParent(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRelatedProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelatedProductsByParent(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getUpsellProduct = /* GraphQL */ `
  query GetUpsellProduct($company: ID!, $id: ID!) {
    getUpsellProduct(company: $company, id: $id) {
      company
      id
      parentId
      productId
      seq
      createdAt
      updatedAt
      parent {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listUpsellProducts = /* GraphQL */ `
  query ListUpsellProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelUpsellProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUpsellProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listUpsellByParentId = /* GraphQL */ `
  query ListUpsellByParentId(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUpsellProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUpsellByParentId(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getCrossSellProduct = /* GraphQL */ `
  query GetCrossSellProduct($company: ID!, $id: ID!) {
    getCrossSellProduct(company: $company, id: $id) {
      company
      id
      parentId
      productId
      seq
      createdAt
      updatedAt
      parent {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
      product {
        company
        id
        comloc
        sku
        type
        name
        slug
        excerpt
        mediaId
        description
        attributes {
          name
          type
          value
        }
        status
        price
        deposit
        cost
        dimensions {
          height
          width
          weight
          length
        }
        qtyOnHand
        qtyAvailable
        qtyReserved
        createdAt
        updatedAt
        version
        settings {
          nextToken
        }
        bundleProducts {
          nextToken
        }
        features {
          nextToken
        }
        stockItems {
          nextToken
        }
        categories {
          nextToken
        }
        upsellProducts {
          nextToken
        }
        crossSellProducts {
          nextToken
        }
        image {
          company
          id
          url
          name
          createdAt
          updatedAt
        }
        media {
          nextToken
        }
        customPrice {
          nextToken
        }
      }
    }
  }
`;
export const listCrossSellProducts = /* GraphQL */ `
  query ListCrossSellProducts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCrossSellProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCrossSellProducts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const listCrossSellByParentId = /* GraphQL */ `
  query ListCrossSellByParentId(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCrossSellProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCrossSellByParentId(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        productId
        seq
        createdAt
        updatedAt
        parent {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
        product {
          company
          id
          comloc
          sku
          type
          name
          slug
          excerpt
          mediaId
          description
          status
          price
          deposit
          cost
          qtyOnHand
          qtyAvailable
          qtyReserved
          createdAt
          updatedAt
          version
        }
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($company: ID!, $id: ID!) {
    getCategory(company: $company, id: $id) {
      company
      id
      name
      description
      slug
      imageUrl
      parentId
      seq
      hidden
      createdAt
      updatedAt
      products {
        items {
          company
          id
          categoryId
          productId
          seq
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          company
          id
          name
          description
          slug
          imageUrl
          parentId
          seq
          hidden
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listCategorys = /* GraphQL */ `
  query ListCategorys(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCategorys(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        name
        description
        slug
        imageUrl
        parentId
        seq
        hidden
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCategoriesBySlug = /* GraphQL */ `
  query ListCategoriesBySlug(
    $slug: String
    $company: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesBySlug(
      slug: $slug
      company: $company
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        name
        description
        slug
        imageUrl
        parentId
        seq
        hidden
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listCategoriesByParentId = /* GraphQL */ `
  query ListCategoriesByParentId(
    $parentId: ID
    $company: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoriesByParentId(
      parentId: $parentId
      company: $company
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        name
        description
        slug
        imageUrl
        parentId
        seq
        hidden
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getMedia = /* GraphQL */ `
  query GetMedia($company: ID!, $id: ID!) {
    getMedia(company: $company, id: $id) {
      company
      id
      url
      name
      attributes {
        name
        type
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const listMedias = /* GraphQL */ `
  query ListMedias(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelMediaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listMedias(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        url
        name
        attributes {
          name
          type
          value
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getShippingZone = /* GraphQL */ `
  query GetShippingZone($company: ID!, $id: ID!) {
    getShippingZone(company: $company, id: $id) {
      company
      id
      name
      regions
      createdAt
      updatedAt
      shippingRegions {
        items {
          company
          id
          zoneId
          description
          type
          data
          createdAt
          updatedAt
        }
        nextToken
      }
      shippingMethods {
        items {
          company
          id
          zoneId
          shippingMethodId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listShippingZones = /* GraphQL */ `
  query ListShippingZones(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelShippingZoneFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShippingZones(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        name
        regions
        createdAt
        updatedAt
        shippingRegions {
          nextToken
        }
        shippingMethods {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listShippingZonesByRegion = /* GraphQL */ `
  query ListShippingZonesByRegion(
    $company: ID
    $regions: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShippingZoneFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippingZonesByRegion(
      company: $company
      regions: $regions
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        name
        regions
        createdAt
        updatedAt
        shippingRegions {
          nextToken
        }
        shippingMethods {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getShippingRegion = /* GraphQL */ `
  query GetShippingRegion($company: ID!, $id: ID!) {
    getShippingRegion(company: $company, id: $id) {
      company
      id
      zoneId
      description
      type
      data
      createdAt
      updatedAt
      shippingZone {
        company
        id
        name
        regions
        createdAt
        updatedAt
        shippingRegions {
          nextToken
        }
        shippingMethods {
          nextToken
        }
      }
    }
  }
`;
export const listShippingRegions = /* GraphQL */ `
  query ListShippingRegions(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelShippingRegionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShippingRegions(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        zoneId
        description
        type
        data
        createdAt
        updatedAt
        shippingZone {
          company
          id
          name
          regions
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listShippingRegionsByZone = /* GraphQL */ `
  query ListShippingRegionsByZone(
    $company: ID
    $zoneId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShippingRegionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippingRegionsByZone(
      company: $company
      zoneId: $zoneId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        zoneId
        description
        type
        data
        createdAt
        updatedAt
        shippingZone {
          company
          id
          name
          regions
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const listShippingRegionsByTypeData = /* GraphQL */ `
  query ListShippingRegionsByTypeData(
    $company: ID
    $typeData: ModelShippingRegionByTypeDataCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelShippingRegionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShippingRegionsByTypeData(
      company: $company
      typeData: $typeData
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        zoneId
        description
        type
        data
        createdAt
        updatedAt
        shippingZone {
          company
          id
          name
          regions
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getShippingMethod = /* GraphQL */ `
  query GetShippingMethod($company: ID!, $id: ID!) {
    getShippingMethod(company: $company, id: $id) {
      company
      id
      type
      name
      cost
      address {
        text
        name
        address1
        address2
        address3
        zip
        city
        region
        country
        coordinates {
          lat
          lon
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listShippingMethods = /* GraphQL */ `
  query ListShippingMethods(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelShippingMethodFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listShippingMethods(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        type
        name
        cost
        address {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getZoneShippingMethod = /* GraphQL */ `
  query GetZoneShippingMethod($company: ID!, $id: ID!) {
    getZoneShippingMethod(company: $company, id: $id) {
      company
      id
      zoneId
      shippingMethodId
      createdAt
      updatedAt
      shippingMethod {
        company
        id
        type
        name
        cost
        address {
          text
          name
          address1
          address2
          address3
          zip
          city
          region
          country
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export const listZoneShippingMethods = /* GraphQL */ `
  query ListZoneShippingMethods(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelZoneShippingMethodFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listZoneShippingMethods(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        zoneId
        shippingMethodId
        createdAt
        updatedAt
        shippingMethod {
          company
          id
          type
          name
          cost
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const getProductPrice = /* GraphQL */ `
  query GetProductPrice($company: ID!, $id: ID!) {
    getProductPrice(company: $company, id: $id) {
      company
      id
      productId
      startTime
      endTime
      price
      createdAt
      updatedAt
    }
  }
`;
export const listProductPrices = /* GraphQL */ `
  query ListProductPrices(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelProductPriceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProductPrices(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        productId
        startTime
        endTime
        price
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDiscount = /* GraphQL */ `
  query GetDiscount($company: ID!, $id: ID!) {
    getDiscount(company: $company, id: $id) {
      company
      id
      name
      rules {
        conditionScope
        condition {
          ne
          eq
          le
          lt
          ge
          gt
          between
        }
        discountScope
        type
        value
      }
      createdAt
      updatedAt
    }
  }
`;
export const listDiscounts = /* GraphQL */ `
  query ListDiscounts(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelDiscountFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDiscounts(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        name
        rules {
          conditionScope
          discountScope
          type
          value
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($company: ID!, $id: ID!) {
    getLog(company: $company, id: $id) {
      company
      id
      parentId
      event
      source
      destination
      description
      data
      createdAt
      updatedAt
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $company: ID
    $id: ModelIDKeyConditionInput
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLogs(
      company: $company
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        company
        id
        parentId
        event
        source
        destination
        description
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLogByParentId = /* GraphQL */ `
  query ListLogByParentId(
    $company: ID
    $parentId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogByParentId(
      company: $company
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        event
        source
        destination
        description
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listLogByParentIdEvent = /* GraphQL */ `
  query ListLogByParentIdEvent(
    $company: ID
    $parentIdEvent: ModelLogByParentIdEventCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogByParentIdEvent(
      company: $company
      parentIdEvent: $parentIdEvent
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        company
        id
        parentId
        event
        source
        destination
        description
        data
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
